import { Group, Layer, Rect, Text } from "react-konva";
import {
  OVERHANG_COLOR,
  OVERHANG_INVALID_COLOR,
  type FrontOverhangMarker,
} from "../../common/frontOverhangView";
import type { PlanogramWorldRect } from "./types";

interface MarkedRect extends PlanogramWorldRect {
  id: string;
  frontOverhang?: FrontOverhangMarker | null;
}

const Marker = ({
  entity,
  scale,
  outline,
}: {
  entity: MarkedRect;
  scale: number;
  outline: boolean;
}) => {
  const marker = entity.frontOverhang;
  if (!marker) return null;
  const width = Math.min(entity.width, (outline ? 112 : 54) / scale);
  const color = marker.invalid ? OVERHANG_INVALID_COLOR : OVERHANG_COLOR;
  return (
    <Group
      listening={false}
      name={`front-overhang-${outline ? "shelf" : "product"}-${entity.id}`}
      x={entity.x + entity.width - width}
      y={outline ? entity.y + entity.height : entity.y}
    >
      <Rect
        width={width}
        height={16 / scale}
        fill={outline ? "white" : color}
        stroke={color}
        strokeWidth={1 / scale}
        cornerRadius={2 / scale}
      />
      <Text
        text={marker.label}
        width={width}
        height={16 / scale}
        fontSize={10 / scale}
        fill={outline ? color : "white"}
        align="center"
        verticalAlign="middle"
        wrap="none"
        ellipsis
      />
    </Group>
  );
};

export const FrontOverhangMarkers = ({
  products,
  shelves,
  scale,
}: {
  products: readonly MarkedRect[];
  shelves: readonly MarkedRect[];
  scale: number;
}) => (
  <Layer listening={false} name="front-overhang-markers">
    {shelves
      .filter((entity) => entity.frontOverhang)
      .map((entity) => (
        <Marker key={entity.id} entity={entity} scale={scale} outline />
      ))}
    {products
      .filter((entity) => entity.frontOverhang)
      .map((entity) => (
        <Marker key={entity.id} entity={entity} scale={scale} outline={false} />
      ))}
  </Layer>
);
